function formatCurrency(number, symbol = "S/.") {
  if (isNaN(number)) number = 0;
  return `${symbol} ${parseFloat(number)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
}

export default formatCurrency;
